import request from '@/api/request.js'

// 新增
export function SystemRoleInsert(data) {
    return request({
        url: '/api/role/systemroleinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemRoleDelete(id) {
    return request({
        url: `/api/role/systemroledelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemRoleUpdate(id, data) {
    return request({
        url: `/api/role/systemroleupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemRoleGetById(id) {
    return request({
        url: `/api/role/getsystemrolebyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemRoleGetList(params) {
    return request({
        url: '/api/role/getsystemrolelist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemRoleGetPageList(params) {
    return request({
        url: '/api/role/getsystemrolepagelist',
        method: 'get',
        params: params
    })
}